import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = { unavailable: String }

  loaded(event) {
    if (event.target !== this.element) return

    $(this.element).find('[data-toggle="popover"]').popover()
  }

  disconnect() {
    $(this.element).find('[data-toggle="popover"]').popover('dispose')
  }

  fail(event) {
    if (event.target !== this.element) return

    event.preventDefault()
    this.element.textContent = this.unavailableValue
  }
}
